module.exports = __webpack_public_path__ + "static/media/message-white.91416cf7.svg";